import { ArrowForward, Close } from '@interhyp/platform-icons';
import Tippy from '@tippyjs/react/headless';
import classnames from 'classnames';
import React, { useRef } from 'react';
import { Typography } from "../typography/Typography.js";
import styles from "./GuidingTooltip.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GuidingTooltip = ({
  appendTo = 'parent',
  className,
  title,
  children,
  open,
  placement = 'auto',
  content,
  onClose,
  zIndex = 900,
  offset = [50, 50]
}) => {
  const classes = classnames(styles.guidingTooltip, open && styles.open, className);
  const childRef = useRef(null);
  return /*#__PURE__*/_jsx(Tippy, {
    reference: childRef,
    zIndex: zIndex,
    offset: offset,
    placement: placement,
    visible: open,
    appendTo: appendTo,
    interactive: true,
    render: attrs => /*#__PURE__*/_jsxs("div", {
      className: classes,
      role: "alert",
      tabIndex: -1,
      ...attrs,
      children: [/*#__PURE__*/_jsxs("header", {
        className: styles.header,
        children: [title && /*#__PURE__*/_jsx(Typography, {
          variant: "h2",
          margin: false,
          children: title
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          className: styles.closeButton,
          onClick: onClose,
          "aria-label": "close",
          children: /*#__PURE__*/_jsx(Close, {})
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.contentContainer,
        children: content
      }), /*#__PURE__*/_jsx("div", {
        "data-popper-arrow": "",
        className: styles.arrowContainer,
        children: /*#__PURE__*/_jsx(ArrowForward, {
          size: 42,
          className: styles.arrow
        })
      })]
    }),
    children: /*#__PURE__*/_jsx("span", {
      ref: childRef,
      children: children
    })
  });
};